import React from "react";
import {URLs, JoinModes, PaymentTypes} from "../../common/constants";
import MessagePage from "./MessagePage";
import {getUrlParams} from "../../common/utils";
import {translate} from '../../i18n/translate.js';

class ThankYouPage extends React.Component {
    getThankYouMessage = () => {
        let messageTitle = '';
        let messageBody = '';
        if(this.props.isWaitListOnly) {
            messageTitle = translate('_thankYouSignUpWaitlistTitle');
            messageBody = translate('_thankYouSignUpWaitlistBody');
        }else if(getUrlParams().transaction === 'declined'){
            //Transaction was declined
            messageTitle = translate('_thankYouDeclinedTitle');
            messageBody = translate('_thankYouDeclinedBody');
        }else if(this.props.pageContext === URLs.STORE){
            //Store
            if ((this.props.extraMessage || '').includes('_PAY_SINGLE_LINK_')) {
                messageTitle = 'Order partially paid';
                messageBody = '';
            } else {
                messageTitle = translate('_thankYouTitle');
                messageBody = translate('_thankYouBody');
            }
        }else if(this.props.pageContext === URLs.PAY && this.props.mode !== PaymentTypes.SINGLE_PAYMENT.type){
            //Update payment details
            messageTitle = translate('_thankYouUpdatePaymentDetailsTitle');
            messageBody = translate('_thankYouUpdatePaymentDetailsBody');
        }else if(this.props.pageContext === URLs.PAY){
            //Make Payment
            messageTitle = translate('_thankYouPaymentTitle');
            messageBody = translate('_thankYouPaymentBody');
        }else if(this.props.pageContext === URLs.CHARGE && this.props.mode === PaymentTypes.PAYMENT_TOKEN.type){
            //Admin: Update payment details
            messageTitle = translate("_thankYouUpdatePaymentDetailsTitle");
            messageBody = translate('_paymentSuccessfullyUpdated');
        }else if(this.props.pageContext === URLs.CHARGE && this.props.mode === PaymentTypes.PAYMENT_PLAN.type){
            //Admin: Update payment plan
            messageTitle = translate('Update Payment Plan');
            messageBody = translate('_planSuccessfullyUpdated');
        }else if(this.props.pageContext === URLs.CHARGE){
            //Admin: Charge member
            messageTitle = translate('Charge Member');
            messageBody = translate('_successfullyCharged');
        }else if(this.props.pageContext === URLs.JOIN && this.props.mode === JoinModes.ADD){
            //Add Subscription
            messageTitle = translate('_thankYouChangeSubscriptionTitle');
            messageBody = translate('_thankYouChangeSubscriptionBody');
        }else if(this.props.pageContext === URLs.JOIN){
            //Signup
            messageTitle = translate('_thankYouSignUpTitle');
            messageBody = ((this.props.extraMessage || '').includes('_PAY_SINGLE_LINK_')) ? '' : translate('_thankYouSignUpBody');
            if (this.props.staticData && this.props.staticData.joinThankYouMessageLinkToStore) {
                const path = '/' + URLs.STORE + '/' + this.props.farmUrl;
                messageBody += "<br><br><a class='no-subscription-join-button' href=" + path + "><button class='button btn btn-primary'>Add one time orders</button></a>";
            }
        }
        if(this.props.pageContext === URLs.CHARGE)
            messageBody += "<br>" + translate("_refreshTheDashboard");

        //If sold out
        if (this.props.thankYouMessage) {
            messageBody += '<br>' + translate(this.props.thankYouMessage);
        }
        return {
            messageTitle : messageTitle,
            messageBody: messageBody,
            messageExtra: (this.props.extraMessage || '')
                .replace("_PAY_SINGLE_LINK_", 'class="link-action" target="_blank" href="' + "/" + URLs.PAY + "/" + this.props.farmUrl + "/" + this.props.seasonUrl + '/?source=account&type=single"'),
        }
    };

    componentDidMount() {
        if (this.props.pageContext === URLs.JOIN &&
            this.props.mode === JoinModes.NEW &&
            this.props.customConfirmationScript &&
            getUrlParams().transaction !== 'declined'){
            let initialScript = "";
            if (this.props.amountText) {
                initialScript = 'var amount = "' + this.props.amountText + '"; ';
            }
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.innerHTML = initialScript + this.props.customConfirmationScript;
            document.body.appendChild(script);
        }
    };

    render() {
        const messageData = this.getThankYouMessage();
        let backUrl = undefined;
        let backText = '';
        if (this.props.pageContext === URLs.STORE) {
            backUrl = "/" + URLs.STORE + "/" + this.props.farmUrl;
            backText = translate('Back to Store');
        }else if (this.props.pageContext === URLs.PAY) {
            backUrl = "/" + URLs.ACCOUNT + "/" + this.props.farmUrl + "/" + this.props.seasonUrl;
            backText = translate('Back to Account');
        }

        return (
            <MessagePage
                messageData={messageData}
                memberKey={this.props.pageContext === URLs.CHARGE ? undefined : this.props.memberKey}
                link={this.props.pageContext === URLs.CHARGE ? {} : {text:backText, url:backUrl}}/>
        );
    }
}

export default ThankYouPage;


// WEBPACK FOOTER //
// ./src/components/common/ThankYouPage.js